import { Link } from '@tanstack/react-router';
import { aboutCareersCta, aboutMeetTeam } from '~/content/about';
import { cn } from '~/lib/cn';

function SplitHeading({ title, sticky }: { title: string; sticky?: boolean }) {
  return (
    <div
      className={cn(
        'flex items-center pb-0 lg:pb-14',
        sticky && 'lg:sticky lg:top-[150px] lg:mt-[15px]',
      )}>
      <h2 className="text-[19px] font-medium leading-[1.3] text-ink sm:text-[22px]">{title}</h2>
      <div className="ml-4 hidden h-px flex-1 bg-black-6 lg:block" />
    </div>
  );
}

export function AboutMeetTeam() {
  const { title, paragraphs, image } = aboutMeetTeam;
  const srcSet = image.srcSet.map(({ src, width }) => `${src} ${width}w`).join(', ');

  return (
    <section className="px-5 py-16 md:py-20 lg:px-20 lg:py-[120px]">
      <div className="mx-auto w-full max-w-[1280px]">
        <div className="grid grid-cols-1 items-start gap-7 lg:grid-cols-[0.6fr_1fr] lg:gap-10">
          <SplitHeading title={title} sticky />
          <div className="relative">
            <div
              aria-hidden
              className="pointer-events-none sticky top-0 z-[5] -mt-[180px] hidden h-[180px] lg:block"
              style={{
                backgroundImage: 'linear-gradient(#fff 50%, #fff0 81%)',
              }}
            />
            {paragraphs.map((text) => (
              <p
                key={text.slice(0, 48)}
                className="mb-6 text-[24px] font-medium leading-[1.3] tracking-[-0.02em] text-ink sm:mb-9 sm:text-[38px] lg:text-[48px]">
                {text}
              </p>
            ))}
          </div>
        </div>
        <img
          className="mt-[18px] h-auto w-full rounded-2xl sm:mt-6 sm:rounded-[20px] lg:mt-16"
          src={image.src}
          srcSet={srcSet}
          sizes="100vw"
          width={2400}
          height={1600}
          alt={image.alt}
          loading="lazy"
        />
      </div>
    </section>
  );
}

export function AboutCareersCta() {
  const { title, body, cta } = aboutCareersCta;

  return (
    <section className="mb-20 px-5 pt-6 pb-12 md:py-12 lg:px-20 lg:pt-6 lg:pb-12">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-start gap-7 lg:grid-cols-[0.6fr_1fr] lg:gap-10">
        <SplitHeading title={title} />
        <div>
          <p className="mb-6 text-[24px] leading-[1.3] tracking-[-0.02em] text-ink sm:mb-9 sm:text-[38px] lg:mb-9 lg:text-[48px]">
            {body}
          </p>
          <Link
            to={cta.href}
            className="inline-flex min-w-16 items-center justify-center rounded-pill bg-[rgb(120_120_128/0.08)] pt-[12px] pr-[14px] pb-[13px] pl-[14px] text-[16px] font-medium leading-[1.4] tracking-[0.192px] text-ink transition-colors duration-150 hover:bg-red-500 hover:text-white">
            <span>{cta.label}</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
